export enum LabelType {
  PALLET_DYNAMIC = "PALLET_DYNAMIC",
}
